import(/* webpackMode: "eager" */ "/var/www/aminoacidsupplements-src/src/app/page.tsx");
